import { ChannelService } from '@core_n/channels/channels.service';
import { ConnectionPositionPair, Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { ChangeDetectorRef, Component, ElementRef, OnInit, VERSION, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AnalysisBoardService } from '@core_n/analysisBoard/analysisBoard.service';
import { dialogType } from '@core_n/enums';
import { VideoMsgMngrService } from '@core_n/msg/video-mngr.service';
import { ShowErrorsDialogComponent } from '@core_n/show-errors/show-errors.component';
import { TranslateService } from '@ngx-translate/core';
import { name, version } from 'package.json';
import { NAINAT_SYMBOL_CSS } from '../../../app/asp/SensorObject';
import { mainMapMngr } from '../../../core/app/asp/MapMngr';
import { userSettings } from '../../../core/app/common/settings';
import { environment } from '../../environments/environment';
import { AppConfig } from '../app.config';
import { aspMngr } from '../asp/AspMngr';
import * as consts from '../common/consts';
import * as enums from '../common/enums';
import { OverlayPanelsService } from '../common/overlay-panels.service';
import { SessionService } from '../common/session.service';
import * as settings from '../common/settings';
import * as utils from '../common/utils';
import { ConnectDialogComponent } from '../connect/connect-dialog.component';
import { MsgBoxService } from '../msg-boxes/msg-box.service';
import { MsgMngrService } from '../msg/msg-mngr.service';
import { SearchDialogComponent } from '../search/search.component';
import { SecondScreenComponent } from '../second-screen/second-screen.component';
import { SideNavigationService } from '../side-navigation/side-navigation.service';
import { MainStateService } from './../common/main-state.service';
import { ToolBarComponent } from './tool-bar.component';

//
// Upper Bar
//
@Component({
  selector: 'app-upper-bar',
  templateUrl: './upper-bar.component.html',
  styleUrls: ['./upper-bar.component.scss']
})
export class UpperBarComponent implements OnInit {

  userMenuTitles = [];
  viewMenuTitles = [];
  toolsMenuTitles = [];
  windowsMenuTitles = [];
  days = [];

  previousLang: string;
  dayName: string;
  currentDate: string;
  currentTime: string;
  isPlayback: boolean;
  playBackTimeToBar: Date;
  intervalId: any;
  commsColor: string;
  errorsColor: string;
  userMessage: string;
  user: string;

       
  
  title: string = "שומר נתיב";
  euronVersion: string = `Version: ${name} ${AppConfig.version.version} ${environment.name}\nAngular ${VERSION.full}\n` +
    `NeWMI ${settings.NeWMI_VER} using ${AppConfig.settings.map.esri ? 'Esri' : 'OpenLayers'}\nWebGL ${utils.isWebGLSupported() ? 'supported' : 'not supported'}`;
  euroVersionShort: string = `Version: ${version}`;
  @ViewChild('upperBar', { read: ElementRef }) upperBar: ElementRef;


  color: any;
  isSplitScreen: boolean = true;

  constructor(
    protected dialog: MatDialog,
    protected sidenav: SideNavigationService,
    protected cdref: ChangeDetectorRef,
    protected overlay: Overlay,
    private overlayPanelsSvc: OverlayPanelsService,
    protected msgMngr: MsgMngrService,
    protected msgBox: MsgBoxService,
    protected session: SessionService,
    private translateService: TranslateService,
    private videoMngr: VideoMsgMngrService,
    private mainStateService: MainStateService,
    private channelService: ChannelService,
    private analysisSrvc: AnalysisBoardService) {
    let self = this;
    this.color = NAINAT_SYMBOL_CSS;
    settings.userSettings.euroVer = this.euronVersion;
    setInterval(function () { self.refresh() }, 750);



    if (AppConfig.settings.PreProd)
      this.title = "PreProd " + this.title;
  }

  ngOnInit() {
    /* panel is now opened via selector positioned relative to map
     setTimeout(() => this.createPanels());*/
    userSettings.isPlayback.subscribe(status => {
      this.isPlayback = status;
    });
    userSettings.playbackTime.subscribe(status => {
      this.playBackTimeToBar = status;
    });

    this.mainStateService.splitScreenToggleClick$.subscribe(showSplitScreen=> {
      this.isSplitScreen = showSplitScreen
    })
  }

  ngAfterViewInit() {
    settings.setUpperBarHeight(50);
    this.refresh();
  }

  userToolTip() {
    return `${this.user}: ${settings.userSettings.userName}`;
  }

  public onIconClick(){
    this.mainStateService.splitScreensStateToggle();
  }
  private refresh(): void {

    if (this.translateService.currentLang != this.previousLang) {
      this.translateService.get('MENUBAR').subscribe((translated: string) => {
        this.userMenuTitles[0] = translated['LOG_OFF'];
        this.viewMenuTitles[0] = translated['TOGGLE_FULL_SCREEN'];
        this.viewMenuTitles[1] = translated['TOGGLE_SECONDARY_SCREEN'];
        this.toolsMenuTitles[0] = translated['CONNECT_SERVER'];
        this.userMessage = translated['ASK_USER_LOG_OFF'];
        this.days = translated['DAYS'];
        this.user = translated['USER'];
      });

      this.previousLang = this.translateService.currentLang;
    }

    let d: Date;
    if (!this.isPlayback)
      d = new Date();
    else {
      d = new Date(this.playBackTimeToBar);
    }

    let dayName = this.days[d.getDay()];
    if (this.dayName != dayName) {
      this.dayName = dayName;
    }
    let currentDate =
      `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
    if (this.currentDate != currentDate) {
      this.currentDate = currentDate;
    }
    let currentTime =
      `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
    if (this.currentTime != currentTime) {
      this.currentTime = currentTime;
    }
    this.commsColor = !this.msgMngr.initialized() ? 'Red' : (this.msgMngr.connectionOpen() ? 'LimeGreen' : 'Yellow');
    let isNewNotification = JSON.parse(localStorage.getItem(consts.LOCAL_STORAGE_NEW_ERR_NOTIFICATION));
    this.errorsColor = isNewNotification ? 'Red' : 'White';
    this.cdref.detectChanges();
  }

  onSearchClick() {
    if (!this.dialog.getDialogById(dialogType.search))
      this.dialog.open(SearchDialogComponent, SearchDialogComponent.createDialogConfig(this.upperBar.nativeElement.offsetHeight));
  }

  onShowErrorsClick() {
    if (!this.dialog.getDialogById(dialogType.showErrors))
      this.dialog.open(ShowErrorsDialogComponent, ShowErrorsDialogComponent.createDialogConfig(this.upperBar.nativeElement.offsetHeight));
  }

  // onAlertPolygonClick() {
  //   this.dialog.open(AlertPolygonDialogComponent, AlertPolygonDialogComponent.createDialogConfig(this.upperBar.nativeElement.offsetHeight));
  // }

  searchDialogExists() {
    let dialogRef = this.dialog.getDialogById(dialogType.search);
    return dialogRef !== undefined;
  }

  onNavToggle() {
    this.sidenav.toggle();
  }

  onMenuClick(menuTitle, event) {
    if (menuTitle == this.userMenuTitles[0]) {
      this.logOff();
    }
    else if (menuTitle == this.viewMenuTitles[0]) {
      this.onFullScreen();
    }
    else if (menuTitle == this.viewMenuTitles[1]) {
      SecondScreenComponent.toggleShown();
    }
    else if (menuTitle == this.toolsMenuTitles[0]) {
      // this.onConnect();
    }
    // else if (menuTitle == this.windowsMenuTitles[0]) {
    //   this.dialog.open(VideoSelectComponent, VideoSelectComponent.createDialogConfig());
    // }
  }

  private async logOff() {
    let confirmed = await this.msgBox.showConfirmMsgBox(this.userMessage, "LogOff", "Yes", "No");
    if (!confirmed)
      return;
    this.session.setLoggedoff();
  }

  private onFullScreen() {
    if (!document.fullscreenElement) {
      let elem = document.documentElement;
      let methodToInvoke = elem.requestFullscreen || elem['webkitRequestFullScreen'] ||
        elem['mozRequestFullScreen'] || elem['msRequestFullScreen'];
      if (methodToInvoke)
        methodToInvoke.call(elem);
    }
    else {
      let methodToInvoke = document.exitFullscreen || document['webkitExitFullScreen'] ||
        document['mozExitFullScreen'] || document['msExitFullScreen'];
      if (methodToInvoke)
        methodToInvoke.call(document);
    }
  }

  onConnect(event: any) {
    let position = { top: `${event.y + 25}px`, left: `${event.x - 200}px` };
    this.dialog.open(ConnectDialogComponent, ConnectDialogComponent.createDialogConfig(position));
  }

  onConnectClick() {
    aspMngr.deleteAllObjects();
    mainMapMngr.clearObjects();
    this.videoMngr.getSensorsList();
    this.msgMngr.close();
    this.msgMngr.openWebSocket();
  }

  ChannelsClick() {
    this.channelService.showWindow();
  }

  onShowAnalysisClick() {
    this.analysisSrvc.showWindow();
  }

  createPanels() {
    // Create and configure tool bar overlay
    let positions = [
      new ConnectionPositionPair(
        { originX: "start", originY: "bottom" },
        { overlayX: "start", overlayY: "top" },
        settings.userSettings.toolBarX, // offsetX
        settings.userSettings.toolBarY  // offsetY
      )
    ];
    let config = new OverlayConfig({
      positionStrategy: this.overlay.position().flexibleConnectedTo(this.upperBar).withPositions(positions)
    });
    this.overlayPanelsSvc.createPanel(ToolBarComponent, config);
  }

  serverHostname(): string {
    return `${this.msgMngr.hostname}`;
  }

  userPrem(): boolean {
    if (settings.userSettings.userPerm == enums.Permission.ADMIN)
      return true;

    return false;
  }

  permTitle() {
    return `Permissions: ${enums.PermissionTypeTitle(settings.userSettings.userPerm)}`;
  }
}
